export default __webpack_public_path__ + "static/media/image-headphones.c3e08bc8.png";